import React, { useEffect, useState } from "react";
import "./Trophy.css";
import { useAuthStudent } from "../../../../context/StudentLoginContext/StudentAuthContext";
import { Modal } from "react-bootstrap";
import TrophyCarousel from "./TrophyCarousel";
import { StudentMapMenuLight } from "../../Map/MapMenu/MapMenuLight";
import BackButton from "../../GoBack/GoBack";

const apiUrl = process.env.REACT_APP_API_URL;

export const StudentAdminTrophy = () => {
  const [trophies, setTrophies] = useState([]);
  const { student,fetchWithAuthStudent } = useAuthStudent();
  const [showModal, setShowModal] = useState(false);
  const [awardTitle, setawardTitle] = useState("");
  const [selectedTrophy, setSelectedTrophy] = useState(null); // ✅ New state for selected trophy
  useEffect(() => {
    if (!student || !student.student) {
      return;
    }

    const fetchTrophies = async () => {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 seconds

      try {
        const response = await fetchWithAuthStudent(
          `${apiUrl}/student/${student?.student?.id}/trophies`,
          {
            method: "GET",
            
            signal: controller.signal,
          }
        );

        clearTimeout(timeoutId);

        if (!response.ok) {
          throw new Error("Failed to fetch trophies");
        }

        const data = await response.json();
        setTrophies(data?.data);
      } catch (err) {
        if (err.name === "AbortError") {
          alert(
            "Request timed out. Please check your internet connection and try again."
          );
        } else {
          alert("Failed to fetch trophies. Please try again later.");
        }
      }
    };

    fetchTrophies();
  }, [student,fetchWithAuthStudent]);

  const ModalTrophy = () => {
    return (
      <>
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          size="lg"
          className="modal-dialog-centered trophy-modal"
        >
          <Modal.Header className="text-white">
            <Modal.Title className="w-100 text-center text-white fs-4">
              {awardTitle}
            </Modal.Title>
            <i className="bi bi-x fs-4" onClick={() => setShowModal(false)}></i>
          </Modal.Header>
          <Modal.Body className="d-flex justify-content-center align-items-center p-0">
            <div className="trophy-content">
              {selectedTrophy && (
                <img
                  className="img-fluid"
                  src={selectedTrophy?.trophyFile}
                  alt="award"
                />
              )}
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  };
  return (
    <>
      <div
  style={{
    backgroundImage: "url('https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/award/trophy/trophybackground.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
  className="d-flex justify-content-center align-items-center min-vh-100"
>
        <div className="StudentAdminBody StudentBodyMrgn">
          
          <div className="container-fluid ">
          <div className="teacher-bodycontent " >
          <BackButton variant="white" />
          </div>
            <div className="justify-content-center align-items-center min-vh-100">
              <div className="">
                <div style={{ position: "absolute" }}>
                  <img
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/award/trophy/trophybackground.png"
                    alt="background"
                    className="fullscreen-image"
                  />
                </div>
                <div className="text-center center-content">
                  <p className="award-text BartenderFont ">TROPHIES</p>
                  <span className="text-white fs-4">
                    Celebrate Your Learning Journey!
                  </span>
                </div>
                <div className="col-md-12 d-none d-md-block mt-5">
                  <TrophyCarousel trophies={trophies} />
                </div>
                <div className="container awardSection d-md-none">
                  <div className="row justify-content-center ">
                    {trophies?.map((trophy, index) => (
                      <div
                        className="col-6 col-md-3 d-flex justify-content-center mb-3"
                        key={index}
                      >
                        <div className="text-center">
                          <div className="award-container position-relative">
                            <img
                              src={
                                trophy?.is_awarded
                                  ? "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/award/trophy/trophycover.png"
                                  : "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/award/trophy/trophydisable.png"
                              }
                              alt="border"
                              className="img-fluid award-frame w-100"
                              style={{
                                opacity: trophy?.is_awarded ? 1 : 1,
                                filter: trophy?.is_awarded ? "none" : "",
                                transition:
                                  "opacity 0.3s ease-in-out, filter 0.3s ease-in-out",
                              }}
                            />
                            <div className="award-image-wrapper position-absolute top-50 start-50 translate-middle">
                              <img
                                src={trophy?.trophyFile}
                                alt="award"
                                className="img-fluid award-image object-fit-contain"
                                style={{
                                  maxWidth: "90%",
                                  maxHeight: "90%",
                                  opacity: trophy?.is_awarded ? 1 : 0.5,
                                  filter: trophy?.is_awarded
                                    ? "none"
                                    : "grayscale(50%)",
                                  transition:
                                    "opacity 0.3s ease-in-out, filter 0.3s ease-in-out",
                                }}
                                onClick={() => {
                                  if (trophy?.is_awarded) {
                                    setShowModal(true);
                                    setawardTitle(trophy?.title);
                                    setSelectedTrophy(trophy); // ✅ Set selected trophy
                                  }
                                }}
                              />
                              {!trophy?.is_awarded && (
                                <img
                                src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/award/LockIcon.png"
                                alt="lock"
                                  className="img-fluid allow-image object-fit-contain position-absolute"
                                  style={{
                                    maxWidth: "50%",
                                    maxHeight: "30%",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                  }}
                                />
                              )}
                            </div>
                          </div>
                          <p
                            className="text-white"
                            style={{ fontSize: "20px", fontWeight: "600" }}
                          >
                            {trophy?.title}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <ModalTrophy />
              </div>
            </div>

            <div className="teacher-bodycontent mb-4">
              <StudentMapMenuLight />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
